import { Mapper, ReadOnly } from 'module/Common';
import { Size } from 'module/Model/Size';

export type MzImageResolution = ReadOnly<MzImageResolution.Shape>;

export namespace MzImageResolution {
  export interface Shape {
    url: string;
    width: number;
    height: number;
  }

  export const create = (url: string, width: number, height: number): MzImageResolution => ({ url, width, height });

  export const mapper = Mapper.map(Mapper.tuple3(Mapper.num, Mapper.num, Mapper.str), vals =>
    create(vals[2], vals[0], vals[1])
  );

  export const getUrl = (model: MzImageResolution) => model.url;
  export const getWidth = (model: MzImageResolution): number => model.width;
  export const getHeight = (model: MzImageResolution): number => model.height;
  export const getSize = (model: MzImageResolution): Size => Size.create(getWidth(model), getHeight(model));
}



// WEBPACK FOOTER //
// ./src/module/Model/MzImage/MzImageResolution.ts